import {FC} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import {OfficeSelector} from 'features/offices/OfficeSelector'
import styles from './OfficesSelectBox.scss'

interface OfficesSelectBoxProps {
  name: string
}

export const OfficesSelectBox: FC<OfficesSelectBoxProps> = ({name}) => {
  const {control} = useFormContext()
  const {field} = useController({name, control})
  return (
    <div className={styles.officesSelectBox}>
      <OfficeSelector
        multiple
        filterByCurrentOffices
        selectedIds={field.value}
        onChange={(value) => {
          field.onChange(value)
          field.onBlur()
        }}
      />
    </div>
  )
}
